// extracted by mini-css-extract-plugin
module.exports = {"filterSection":"styles_filterSection__ULGsb","collectionFilter":"styles_collectionFilter__fc3qq","selectedCollection":"styles_selectedCollection__uMgU5"};